import _ from 'lodash'
import { DomApplier } from '../cssFeatures.types'
import { SelectorObj } from '../../shared.types'
import { ZIndexCss, ZIndexCssPage } from './zIndexCss.types'

export const zIndexCssDomApplier: DomApplier<'zIndexCss'> = (__, ___, ____, zIndexCssDetails, _____) => {
	if (!zIndexCssDetails || !zIndexCssDetails.defaultZIndexCss || zIndexCssDetails.defaultZIndexCss?.component) {
		return null
	}
	const { defaultZIndexCss } = zIndexCssDetails as { defaultZIndexCss: ZIndexCssPage }
	const acc: SelectorObj = {}

	_(defaultZIndexCss).forEach((zIndexDetails, selector) => {
		acc[`#${selector}`] = zIndexDetails as ZIndexCss
	})
	return acc
}
